import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

// Components
import {
    CircularProgress,
    Fab,
    Paper,
    Typography,
    Grid,
} from '@material-ui/core';

import { Button } from 'devextreme-react';

import {
    Check as CheckIcon,
    Save as SaveIcon,
    Error as ErrorIcon,
} from '@material-ui/icons';


// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    paperError: {
        width: '280px',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    message: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        padding: '5px 10px 5px 10px !important'
    },
    overlay: {
        position: 'fixed',
        zIndex: '1300',
        right: '0px',
        bottom: '0px',
        top: '0px',
        left: '0px',
    },
    wrapper: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        zIndex: -1,
        position: 'fixed',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    progressWrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
    fabProgress: {
        color: '#3f51b5',
        position: 'absolute',
        top: -6,
        left: -6,
        zIndex: 1,
    },
    circle: {
        color: '#fff',
    },
    buttonSuccess: {
        backgroundColor: '#5cb85c',
        '&:hover': {
            backgroundColor: '#46a046',
        },
    },
    buttonErrored: {
        backgroundColor: '#d9534f',
        '&:hover': {
            backgroundColor: '#ce312c',
        },
    },
    buttonProgress: {
        backgroundColor: '#3f51b5',
        '&:hover': {
            backgroundColor: '#3f51b5',
        },
    },
});


const ErrorCmp = props => {
    const { errorMessage, closeErrorActions, tryAgainAction, classes } = props;

    return (

        <Paper className={classes.paperError}>
            <Grid container spacing={3} /*className={classes.mainGrid}*/>

                <Grid item xs={12} className={classes.alignCenter}>
                    <Fab
                        aria-label="save"
                        color="primary"
                        className={classes.buttonErrored}
                    >
                        <ErrorIcon />
                    </Fab>
                </ Grid>

                {errorMessage ?

                    <Fragment>
                        <Grid item xs={12} className={classes.message}>
                            <Typography variant="subtitle2" >
                                Si è verificato il seguente errore:
                            </Typography>

                        </ Grid>
                        <Grid item xs={12} className={classes.message}>
                            <Typography variant="subtitle1" >
                                {errorMessage}
                            </Typography>

                        </ Grid>
                    </Fragment>
                    :
                    <Grid item xs={12} className={classes.message}>
                        <Typography variant="subtitle1" >
                            Ops.L'operazione non è andata a buon fine.
                        </Typography>

                    </ Grid>

                }

                <Grid item xs={12} >
                    <Grid container spacing={1} >
                        <Grid item xs={6} className={classes.alignCenter}>
                            <Button
                                width={120}
                                text="Indietro"
                                type="normal"
                                stylingMode="outlined"
                                onClick={() => closeErrorActions()}
                            />
                        </ Grid>

                        <Grid item xs={6} className={classes.alignCenter} >
                            <Button
                                width={120}
                                text="Riprova"
                                type="default"
                                stylingMode="contained"
                                onClick={() => tryAgainAction()}
                            />
                        </ Grid>
                    </ Grid>
                </Grid>

            </ Grid>
        </Paper>

    );
};



// utilizzato nei componenti che eseguono action che richiedono risposte dal web service
class ActionProgress extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            success: false,
            errored: false,

            showProgress: false,
            showErrorActions: false,
        };

        this.closeErrorActions = this.closeErrorActions.bind(this);
        this.tryAgain = this.tryAgain.bind(this);
    }

    componentDidUpdate(propsPrecedenti) {
        if (this.props.status !== propsPrecedenti.status) {

            if (this.props.status === 'PENDING') {
                this.setState(prevState => ({
                    ...prevState,
                    loading: true,
                    success: false,
                    errored: false,
                    showProgress: true,
                }),
                    () => {
                        // this.props.eseguiQualcosa());
                    }
                );
            }
            if (this.props.status === 'RESOLVED') {

                setTimeout(() => {
                    this.setState(prevState => ({
                        ...prevState,
                        loading: false,
                        success: true,
                        errored: false,
                    }),
                        () => {
                            setTimeout(() => {
                                this.setState(prevState => ({
                                    ...prevState,
                                    showProgress: false,
                                }), () => { //una volta completata con successo l'action eseguo afterResolvedAction nel caso fosse definita 
                                    if (this.props.afterResolvedAction !== undefined)
                                        this.props.afterResolvedAction();
                                }
                                );
                            }, 2000);
                        }
                    );
                }, 2000);
            }

            if (this.props.status === 'ERRORED') {

                setTimeout(() => {
                    this.setState(prevState => ({
                        ...prevState,
                        loading: false,
                        success: false,
                        errored: true,
                    }),
                        () => {
                            // se tryAgainAction è definita, mostro i bottoni "Indietro" e "Riprova"
                            if (this.props.tryAgainAction !== undefined)
                                this.setState(prevState => ({
                                    ...prevState,
                                    showErrorActions: true,
                                }));
                            // altrimenti setto timer che faccia dissolvere ActionProgress automaticamente
                            else
                                setTimeout(() => {
                                    this.setState(prevState => ({
                                        ...prevState,
                                        showProgress: false,
                                    }));
                                }, 2000);
                        }
                    );
                }, 2000);
            }
        }
    }

    closeErrorActions() {
        this.setState({
            showProgress: false,
            showErrorActions: false,
            errored: false,
        });
    }

    tryAgain() {
        this.setState({
            showErrorActions: false,
            errored: false,
        });
        this.props.tryAgainAction();
    }



    render() {
        const { classes, errorMessage } = this.props;
        const { loading, success, errored, showProgress, showErrorActions } = this.state;


        if (showProgress)
            return (
                <div className={classes.overlay}>
                    <div className={classes.wrapper}>

                        <div className={classes.progressWrapper}>
                            {!showErrorActions && !errored ?
                                <Fab
                                    aria-label="save"
                                    color="primary"
                                    className={loading ? classes.buttonProgress
                                        : success ? classes.buttonSuccess : null
                                    }
                                >
                                    {loading && !success && !errored && <SaveIcon />}
                                    {!loading && success && !errored && <CheckIcon />}
                                </Fab>
                                : null
                            }
                            {loading && <CircularProgress size={68} className={classes.fabProgress} />}
                        </div>

                        {errored && showErrorActions &&
                            <ErrorCmp
                                errorMessage={errorMessage}
                                closeErrorActions={this.closeErrorActions}
                                tryAgainAction={this.tryAgain}
                                classes={classes}
                            />
                        }
                    </div>
                </div>
            );
        else return null;
    }
}

ActionProgress.propTypes = {
    status: PropTypes.string.isRequired,
    errorMessage: PropTypes.string,
    afterResolvedAction: PropTypes.func,
    tryAgainAction: PropTypes.func,
};

export default withStyles(styles)(ActionProgress);